import ROUTE from "@app/navigationApp/routes"
import Button from "@app/sharedComponents/Button/Button"
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import NumStepper from "@app/sharedComponents/NumStepper/NumStepper"
import { ThemedText, ThemedView } from "@app/theme"
import {Image} from 'react-native'

const UnpledgeInstructions = ({navigation}) => {

    const removePledgeStepsStepperData = [
        {
            "status": "NOT_STARTED",
            "verticalDisplayName": "Select funds and amount",
            "verticalDescription": `Select the funds and specify the amount for which pledge needs to be removed`,
            "order": 0,
            "highLightText": true
        },
        {
            "status": "NOT_STARTED",
            "verticalDisplayName": "Verify using OTP to submit request",
            "verticalDescription": "Lender will verify the request and remove selected funds from your loan account",
            "order": 1,
            "highLightText": true
        },
        {
            "status": "NOT_STARTED",
            "verticalDisplayName": "Track status of your request",
            "verticalDescription": "Your request to unpledge will be shared with SEBI authorised RTAs (CAMS and KFintech). It may take them 4-5 business days to complete unpledging",
            "order": 2,
            "highLightText": true
        },
    ]
    return (<>
              <ThemedView backgroundColor="bg-surface-page" flex = {1}>
            <PageHeaders label="Remove pledge" navigation={navigation} pageName={"UnpledgeInstructions"} />

        <ThemedView borderRadius="lg" backgroundColor="bg-surface-primary" margin="lg">


            <ThemedView padding="lg" backgroundColor='bg-fill-primary' borderRadius='sm'>
                
                <ThemedView flexDirection="row" alignItems="center">

                <Image
                            source={{
                                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/hour_glass_blue.png',
                            }}
                            style={{width: 48, height: 48}}
                        />
                    <ThemedText variant="h5s" marginLeft="lg">Steps to remove pledge</ThemedText>

                </ThemedView>
                <ThemedView flexDirection="row">
                <ThemedView marginTop="lg" flex= {1}>
                <NumStepper data={removePledgeStepsStepperData}/>
                    </ThemedView>

                    {/* <ThemedView marginTop="lg" testID="stepperText" flex={1}>

                        <ThemedText variant="b3s">
                        Select funds and amount
                        </ThemedText>
                        <ThemedText variant="b4r">
                        Select the funds and specify the amount for which pledge needs to be removed
                        </ThemedText>
                        <ThemedText variant="b3s">
                        Verify using OTP to submit request
                        </ThemedText>
                        <ThemedText variant="b4r">
                        Lender will verify the request and remove selected funds from your loan account
                        </ThemedText>
                        <ThemedText variant="b3s">
                        Track status of your request
                        </ThemedText>
                        <ThemedText variant="b4r">
                        Your request to unpledge will be shared with SEBI authorised RTAs (CAMS and KFintech). It may take them 4-5 business days to complete unpledging
                        </ThemedText>

                    </ThemedView> */}
                    
                    </ThemedView>
            </ThemedView>


        </ThemedView>
        <ThemedView  width={'100%'}position="absolute" bottom={1} borderTopWidth={1} borderColor="border-primary" backgroundColor="bg-fill-primary" padding="lg">
            
           <Button  type="SOLID" handlePress={() => {
              navigation.navigate(ROUTE.REMOVE_PLEGE)
                } } label={"Continue to select funds"}/>
        </ThemedView>
        </ThemedView>
        </>
    )
}


export default UnpledgeInstructions